import dayjs from 'dayjs';

// Small helpers the device tabs share.

export const truncate = (text, max) => (text.length > max ? text.slice(0, max) + '…' : text);

export const absoluteTime = (iso) => (iso ? dayjs(iso).format('MMM D, HH:mm:ss') : '—');

export const pageOf = (searchParams) => {
  const page = parseInt(searchParams.get('page'), 10);
  return page > 0 ? page : 1;
};

// The page lives in the URL; page 1 deletes the param.
export const writePage = (setSearchParams, page) =>
  setSearchParams(
    (prev) => {
      const next = new URLSearchParams(prev);
      if (page <= 1) next.delete('page');
      else next.set('page', String(page));
      return next;
    },
    { replace: true },
  );
